import { toDirectoryDTO } from "../../directory-integration/directory-integration.functions";

export class Controller {

    /** @ngInject */
    constructor($state, Alert, ConfirmModal, ApplicationsResource, DirectoriesResource, ShowNoteModal) {
        this.$state = $state;
        this.Alert = Alert;
        this.ConfirmModal = ConfirmModal;
        this.ApplicationsResource = ApplicationsResource;
        this.DirectoriesResource = DirectoriesResource;
        this.ShowNoteModal = ShowNoteModal;
    }

    $onInit() {
        if (this.provisioningDirectory == '' || this.provisioningDirectory == 'null') {
            this.provisioningDirectory = null
        } else {
            this.provisioningDirectory = toDirectoryDTO(this.provisioningDirectory);
        }
        this.userProvisioningEnabled = this.provisioningDirectory != null;
    }

    provisioningSwitchValueChanged(newValue) {
        if (newValue) {
            if (this.provisioningDirectory == null) {
                this.addingModeOn = true;
            }
        } else {
            if (this.provisioningDirectory != null) {
                this.userProvisioningEnabled = !newValue;
                this.ConfirmModal({
                    messageKey:'company.manage-application.scim-provisioning.disable.confirm.message',
                    titleKey:'company.manage-application.scim-provisioning.disable.confirm.title'
                })
                    .then(() => {
                            this.userProvisioningEnabled = newValue;
                            this.disableUserProvisioning(); 
                        }
                    )
                    .finally(() => (this.isSending = false));
            } else {
                this.addingModeOn = false;
            }
        }
    }

    disableUserProvisioning() {
        this.ApplicationsResource.
            removeProvisioningDirectory(this.companyId, this.application.id)
            .then((data)=> {
                this.Alert('success', 'company.manage-application.scim-provisioning.disabled');
                this.$state.go('.', {}, {reload: '.'});
            })
    }

    pauseScimProvisioning() {
        this.DirectoriesResource
            .pauseScimProvisioning(this.companyId, this.provisioningDirectory.id)
            .then(() => {
                this.provisioningDirectory.appProvisioningPaused = true;
                this.Alert('success', 'company.directory-integration.manage.main.updated', {directoryTypeName: this.directory.typeName});
            });
    }

    resumeScimProvisioning() {
        this.DirectoriesResource
        .resumeScimProvisioning(this.companyId, this.provisioningDirectory.id)
        .then(() => {
            this.provisioningDirectory.appProvisioningPaused = false;
            this.Alert('success', 'company.directory-integration.manage.main.updated', {directoryTypeName: this.directory.typeName});
        });
    }

    addScimDirectory() {
        this.DirectoriesResource
            .createScimDirectory(this.companyId, this.newDirectory.name, this.newDirectory.tenantId, true)
            .then((directory) => {
                this.ApplicationsResource.
                    setProvisioningDirectory(this.companyId, this.application.id, directory.id)
                    .then((data)=> {
                        this.Alert('success', 'company.manage-application.scim-provisioning.enabled');
                        this.$state.go('.', {}, {reload: '.'});
                    })
            })
            .finally(() => this.isSaving = false)
    }

    showLatestErrors() {
        this.ShowNoteModal('company.manage-application.scim-provisioning.latest-errors', this.provisioningDirectory.statusDto.lastProvisioningErrorMessage);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/scim-provisioning/scim-provisioning.controller.js